/* eslint-disable complexity */
class LineUp {

    constructor() {
        document.fonts.ready.then(() => {
            this.init();

            // Select first artistlist on pageload
            var pday1 = document.getElementById('program-day-1');
            if (pday1 !== null) {
                pday1.parentNode.classList.add('parent');
            }
        });
    }

    setupProgramSwitcher() {

        const $programSwitcher = document.querySelector('[data-lineup-switcher]');
        $programSwitcher?.addEventListener('change', () => {

            const $optionList = $programSwitcher.querySelectorAll('[name="program"]');

            $optionList?.forEach($option => {
                const $program = document.getElementById($option.value);
                const $transitionList = $program.closest('[data-list-transition]');
                const $button = $option.closest('.c-button');
                const manualState = $option.checked ? 'open' : 'closed';
       
                // trigger transitions
                $transitionList.triggerTransition(manualState);

                // trigger button state
                if ($option.checked) {
                    $button.classList.add('c-button--active');

                    // Deselect selected list and select active one
                    const parent = document.querySelector('.c-lineup__program .parent');
                    if (parent) {
                        parent.classList.remove('parent')
                    }
                    document.getElementById($option.value).parentNode.classList.add('parent');

                } else {
                    $button.classList.remove('c-button--active');
                }
            });
        });
    }

    setItemIndexes($listTransition) {
        const $listItems = $listTransition.querySelectorAll('[data-list-transition-item]');
        let currentIndex = 1;
        let currentPosY = null;

        $listItems.forEach(($item) => {
            const yPos = $item.getBoundingClientRect().top;
            currentPosY = currentPosY || yPos;

            if (yPos !== currentPosY) {
                currentIndex++;
                currentPosY = yPos;
            }

            $item.setAttribute('data-list-transition-item', currentIndex);

        });
    }

    /*
     * Adds Lines between lines of acts.
     * On every run, it will delete all lines and add them again.
     *
     */
    addAndRemoveLinesBetweenLines($day) {
        const $acts = $day.querySelectorAll('[data-lineup-act]');
        const $lines = $day.querySelectorAll('[data-lineup-line]');

        $lines.forEach($line => $line.remove());

        $acts.forEach(($act, index) => {
            const yPos = $act.getBoundingClientRect().top;
            const nextYPos = $acts[index + 1]?.getBoundingClientRect().top;

            if (nextYPos !== yPos) {
                const $line = document.createElement('li');
                $line.classList.add('c-lineup__line');
                $line.classList.add('o-list-transition__item');
                $line.setAttribute('data-lineup-line', undefined);
                $line.setAttribute('data-list-transition-item', undefined);
                $line.setAttribute('aria-hidden', 'true');
                $act.after($line);
            }
        });

    }

    /*
    * Split long acts into words and creates a list item for each word.
    *
    * Per Act:
    *   The first of the new list items wil get all other words appended to it within a span that is visually hidden.
    *   The remaining new list items will get an aria-hidden="true".
    *
    *   Furthermore, all new list items will get a --no-bullet modifier, except for the first one.
    *
    * Per Day:
    *   The last <li>word</li> of the last act, will also get a --no-bullet modifier.
    *
    * Usage:
    *   run only once per page load, from within the init method.
    *
    * */
    prepareActs($day, maxCharacterLength) {
        const newActs = [];
        const $acts = $day?.querySelectorAll('[data-lineup-act]');
        $acts?.forEach(($act, actIndex) => {
            const text = $act.innerText;
            if (text.length < maxCharacterLength) {
                if (actIndex === $acts.length - 1) {
                    $act.classList.add('c-lineup__act--no-bullet');
                }
                newActs.push($act);
                return;
            }
            const classString = $act.classList.value;
            const liParts = [];
            let words = text.split(/(?!&)\s(?!&)/g);
            words = words.filter(w => w !== '');

            words.forEach((word, wordIndex) => {
                this._prepareWordForAct(word, wordIndex, classString, words, liParts, $acts, actIndex);
            })

            newActs.push(...liParts);

        });

        // Test for Android, iOS, or Safari
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream || /^((?!chrome|android).)*safari/i.test(userAgent)) {
            // Mobile OS or Safari
            document.getElementsByClassName("c-lineup__program")[0].classList.add("mobile")
        }
        else {
            // Desktop
            $day.replaceChildren(...newActs);
        }
        
    }

    // utility for prepareActs Method
    _prepareWordForAct(word, wordIndex, classString, words, liParts, $acts, actIndex){
        const $li = document.createElement('li');

        this._prepareListItemForWordOfAct($li, classString);

        // if there is only one word, we don't need to do anything special
        if (words.length === 1) {
            $li.innerText = word;
            this._finalizeAndPushListItemForWordOfAct(wordIndex, actIndex, $acts, words, $li, liParts);
            return;
        }

        // if this is the first word, we need to add the remaining words as a visually hidden span
        if (wordIndex === 0) {
            $li.innerHTML = `
                    <span>${word}</span>
                    <span class="u-visually-hidden">${words.slice(1).join(' ')}</span>`
                .replace(/\s{4,30}/g, '');
            liParts.push($li);
            this._finalizeAndPushListItemForWordOfAct(wordIndex, actIndex, $acts, words, $li, liParts);
            return;
        }

        // otherwise we need to mark the list item as hidden for screen readers
        $li.setAttribute('aria-hidden', 'true');
        $li.innerText = word.replace(/\s/g, '\xa0\xa0\xa0');
        this._finalizeAndPushListItemForWordOfAct(wordIndex, actIndex, $acts, words, $li, liParts);

    }

    // utility for _prepareWord > prepareActs Method
    _prepareListItemForWordOfAct($li, classString) {
        $li.classList.value = classString;
        $li.classList.add('c-lineup__act--no-bullet');
        $li.setAttribute('data-list-transition-item', undefined);
        $li.setAttribute('data-lineup-act', undefined);
    }

    // utility for _prepareWord > prepareActs Method
    _finalizeAndPushListItemForWordOfAct(wordIndex, actIndex, $acts, words, $li, liParts) {
        const lastWordOfLastAct = actIndex === $acts.length - 1 && wordIndex === words.length - 1;

        if (wordIndex === words.length - 1 && !lastWordOfLastAct) {
            $li.classList.remove('c-lineup__act--no-bullet');
        }

        liParts.push($li);
    }

    /*
    * Sets the transition delay for each list item, and adds a line between lines
    */
    prepareLists() {
        const $lineUp = document.querySelector('[data-lineup]');
        const $listTransitions = $lineUp?.querySelectorAll('[data-list-transition]');
        const $days = $lineUp?.querySelectorAll('[data-lineup-day]');
        $days?.forEach(this.addAndRemoveLinesBetweenLines);
        $listTransitions?.forEach(this.setItemIndexes);
    }

    init() {
        this.setupProgramSwitcher();
        const $lineUp = document.querySelector('[data-lineup]');
        const $lineUpDays = $lineUp?.querySelectorAll('[data-lineup-day]');
        $lineUpDays?.forEach(($day) => {
            this.prepareActs($day, 20);
        });
        this.prepareLists();
        this.prepareLists();
        window.addEventListener('resize', () => {
            this.prepareLists();
        })
    }

    static setup() {
        new LineUp();
    }
}

LineUp.setup();


export default null;
